import { Sprout, Check, Flame, Zap, Star, Trophy, Crown, Medal, Users, Swords } from "lucide-react";

export const ACH_ICONS = {
  sprout: Sprout, check: Check, flame: Flame, zap: Zap, star: Star,
  trophy: Trophy, crown: Crown, medal: Medal, users: Users, swords: Swords,
};
